import { useQuery } from '@tanstack/react-query';
import { formatApiError } from '@api/common/errors';
import { getServerConfig } from '@api/server-config';
import { getQueryAlertMessages } from '@app/common/queries/formatters/alerts';
import queryClient from './query-client';
export const keys = {
    config: ['server-confing']
};
export function useGetServerConfig({ enabled }) {
    return useQuery({
        queryKey: keys.config,
        queryFn: getServerConfig,
        enabled,
        meta: getQueryAlertMessages(error => formatApiError(error, 'Failed to load server config')),
        refetchInterval: 60 * 60 * 1000,
        refetchIntervalInBackground: true
    });
}
export function ensureServerConfig() {
    return queryClient.ensureQueryData({
        queryKey: keys.config,
        queryFn: getServerConfig
    });
}
